import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { ButtonIwText } from '@/_pages/interwill/components/ButtonIwText';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { UploadErrorModalProps } from '@/widgets/modals/types';

import { ModalContainerV4 } from '../containers/ModalContainerV4';

export const UploadErrorModal: FC<UploadErrorModalProps> = ({ onConfirm }) => {
  const { closeModal } = useModalsStore();
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'uploadError' });

  return (
    <ModalContainerV4
      title={t('title')}
      pinBottom
      icon={<Icon name="x" style={{ color: COLORS.systemFlame200 }} />}
      iconBackground={COLORS.systemFlame100}
    >
      <p>{t('text')}</p>
      <Buttons>
        <StyledButtonIwText onClick={closeModal}>{t('btnClose')}</StyledButtonIwText>
        <ButtonIw onClick={onConfirm}>{t('btnConfirm')}</ButtonIw>
      </Buttons>
    </ModalContainerV4>
  );
};

const Buttons = styled.div`
  width: 100%;
  margin-top: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledButtonIwText = styled(ButtonIwText)`
  &&& {
    font-weight: 700;
  }
`;
